import { type ReactNode } from "react";
import { Result } from "antd";
import type { Agent } from "./domain";

export const hasAdvertisingAccess = (agent: Pick<Agent, "advertising_enabled">) => agent.advertising_enabled === true;

/** Use the principal loaded by the session shell; APIs enforce current authorization. */
export function AdvertisingAccess({ agent, children }: {
  agent: Agent;
  children: ReactNode;
}) {
  if (!hasAdvertisingAccess(agent)) return <Result status="403" title="广告权限未开通" subTitle="如需管理广告、上传广告素材或查看广告报表，请联系平台管理员开通广告权限。" />;
  return children;
}
